import { graphql, useStaticQuery } from "gatsby";

const useAllPartners = () => {
  return useStaticQuery(graphql`
    query partnersQuery {
      partnersSupertri: contentfulBrand(
        name: { eq: "supertri" }
        node_locale: { eq: "en-GB" }
      ) {
        partners {
          id
          name
          image {
            gatsbyImageData(width: 350, placeholder: NONE)
          }
          url
        }
      }

      partnersSupertrie: contentfulBrand(
        name: { eq: "supertri E" }
        node_locale: { eq: "en-GB" }
      ) {
        partners {
          id
          name
          image {
            gatsbyImageData(width: 350, placeholder: NONE)
          }
          url
        }
      }
    }
  `);
};

export default useAllPartners;
